import React, { useState, useEffect } from "react";
import { getAgentCode } from '__utils/storage';
import { getFormDataFromJson, fetchPost } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { get } from '__utils/ajax-wrapper';
import { isBtoCFlow } from '__utils/common-utils';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { redirectToOld, } from '__utils/common-utils';
import useFlashToggler from 'hooks/use-flash-toggler';
import { CommonStyledComponentProps } from "__utils/type";
import styled from "styled-components";
import { COLOR } from "constants/colors";
import LargePopup from "components/popup/large-popup";
import ConfirmationModal from 'components/confirmation-modal';
import { useMediaQuery } from "react-responsive";
import { getEventName, Mixpanel } from '__utils/mixpanel';
import ReactPlayer from 'react-player';

import { SuccessButton } from 'components/button';
import notificationIcon from "images/notification-icon.png";
import createLeadIcon from "images/create-lead-icon.png";
import thankYouImg from "images/thank-you-img.png";
import crossIcon from "images/cross.svg";

const OuterContent = styled.div<CommonStyledComponentProps>`
  background-color: ${COLOR.WHITE};
  margin: ${(props: CommonStyledComponentProps) =>
    props.isMobile ? `16px` : `0`};
  box-shadow: 0 4px 4px 0 var(--lightGrey);
`;

const SingleViewContentPopup = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const flash = useFlashToggler();

  const [showContentViewPopup, setShowContentViewPopup] = useState(false);
  const [activeContentDetails, setActiveContentDetails] = useState<any>();
  const [dpSubscribed, setDpSubscribed] = useState(false);
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [getVideoThumbnailImg, setGetVideoThumbnailImg] = useState<any>();
  const [showReadMore, setShowReadMore] = useState<boolean>(false);
  const [thankYouStyle, setThankYouStyle] = useState<any>();
  const [addStyle, setAddStyle] = useState<any>();
  const [showThumbnailVideo, setShowThumbnailVideo] = useState(false);
  const [iframeVideoUrl, setIframeVideoUrl] = useState<any>();

  const [videoLoad, setVideoLoad] = useState<any>(true);

  const onCancel = () => {
    setShowContentViewPopup(false);
    document.body.classList.remove('stopScroll');
  }

  const closePopup = () => {
    if (isMobile) document.body.classList.add('fixed-btn');
  }

  useEffect(() => {
    handleReady();
    // setVideoLoad(false);
  }, []);

  const handleReady = () => {
    setVideoLoad(false);
  }

  let urlParam = new URLSearchParams(window.location.search);
  let getCategoryId = urlParam.get('categoryId');

  const getActiveContentDetailsForDP = () => {
    get(ENDPOINTS.GET_ACTIVE__CONTENT_DETAILS_FOR_DP + `?agentCode=${getAgentCode()}`, true)
      .subscribe((response: AjaxResponse | AjaxError) => {
        if (response?.response?.meta?.message === 'success') {
          var categoryIdListArray = response?.response?.data;
          var categoryIdList: any = [];
          categoryIdListArray.filter(function (item: any, index: any) {
            if (item.categoryId == getCategoryId) {
              setShowContentViewPopup(true);
              categoryIdList.push(item);
              //isMobile && document.body.classList.add('stopScroll');
              Mixpanel.track(getEventName("popup", "loaded", "singlecontent"), {
                agentCode: getAgentCode(),
                isBtoCFlow: isBtoCFlow(),
              })
            }
          });

          setDpSubscribed(categoryIdList[0]?.subscribe);
          if (dpSubscribed) {
            setThankYouStyle({ visibility: 'hidden' });
          }
          let thumbNailImg = categoryIdList[0]?.thumbNail;
          if (thumbNailImg) {
            getThumbnailImage(thumbNailImg);
          }
          setActiveContentDetails({
            category: categoryIdList[0]?.category,
            description: categoryIdList[0]?.description,
            heading: categoryIdList[0]?.heading,
            subscribe: categoryIdList[0]?.subscribe,
            thumbNail: categoryIdList[0]?.thumbNail,
            videoUrl: categoryIdList[0]?.videoUrl,
          })
          if (isMobile && categoryIdList[0]?.subscribe) {
            document.body.classList.add('fixed-btn');
          } else {
            document.body.classList.remove('fixed-btn');
          }
        }
      }, (error: AjaxError) => {
      });
  }

  const getThumbnailImage = (thumbNailImgUrl: any) => {
    get(ENDPOINTS.GET_THUMBNAIL_IMAGE + `?fileName=${thumbNailImgUrl}`, true)
      .subscribe((response: AjaxResponse | AjaxError) => {
        if (response) {
          setGetVideoThumbnailImg(response?.request?.url);
        }
      }, (error: AjaxError) => {
        flash.error("Failed to fetch image. Please try again later.");
      });
  }

  const playVideoOnClick = () => {
    setShowThumbnailVideo(true);
    // setIframeVideoUrl(activeContentDetails.videoUrl+"?autoplay=1&loop=1&autopause=0&mute=1");
    setIframeVideoUrl(activeContentDetails.videoUrl);
    Mixpanel.track(getEventName("playcontent", "clicked", "singlecontent"), {
      agentCode: getAgentCode(),
      isBtoCFlow: isBtoCFlow(),
    })
  };

  const dpSubscription = (event: any) => {
    if (event.target.innerText.trim() === 'Get notified') {
      const formData = getFormDataFromJson({
        categoryId: 0,
        subscribe: true,
        agentCode: getAgentCode()
      });
      fetchPost(ENDPOINTS.POST_DP_SUBSCRIPTION, formData, null, true)
        .then((response: any) => {
          if (response?.meta?.message === 'success') {
            // flash.success('DP subscribed successfully.!');
            setDpSubscribed(true);
            setShowThankYouPopup(true);
            setTimeout(function () {
              setThankYouStyle({ visibility: 'hidden' });
              if (isMobile) setShowThankYouPopup(false);
            }, 3000);
          }
        }).catch(() => {
          flash.error("Failed to subscribed dp. Please try again later.");
        });
      Mixpanel.track(getEventName("subscibe", "clicked", "singlecontent"), {
        agentCode: getAgentCode(),
        isBtoCFlow: isBtoCFlow(),
      })
    } else if (event.target.innerText.trim() === 'Create Leads') {
      Mixpanel.track(getEventName("lead", "clicked", "singlecontent"), {
        agentCode: getAgentCode(),
        isBtoCFlow: isBtoCFlow(),
      })
      redirectToOld(`my-customers?agentCode=${getAgentCode()}&source=singleContentView`);
    }
  }

  useEffect(() => {
    getActiveContentDetailsForDP();
  }, []);

  const ThankYouMsgContent = () => {
    return (
      <div className="thank-you-sec">
        <img src={thankYouImg} alt="" />
        <div className="thank-you-txt">
          <h4>Thank you</h4>
          <p>We're excited to share our content and insights with you</p>
        </div>
      </div>
    )
  }

  const popupContent = () => {
    return (
      <>
        {isMobile && showThankYouPopup &&
          <ConfirmationModal
            onCancel={() => setShowThankYouPopup(false)}
            modalBody={<ThankYouMsgContent />}
            closable>
          </ConfirmationModal>
        }
        <div className="first-video video-section" onClick={() => playVideoOnClick()}>
          {!showThumbnailVideo && <><div className="videoDiv"></div>
            <img
              src={getVideoThumbnailImg}
              width="100"
              height="100"
              data-toggle="modal"
              data-target="#myVideoModal"
            /></>}

          {showThumbnailVideo && <>
            <ReactPlayer
              allowFullScreen
              url={iframeVideoUrl}
              controls
              playing
            />
          </>
          }
        </div>
        <div className="desc-section">
          <p className={showReadMore ? '' : 'less'}>
            {activeContentDetails?.description}
            <span className="readMoreBold" onClick={() => setShowReadMore(prevState => !prevState)}>{showReadMore ? 'Read Less' : 'Read More'}</span>
          </p>
        </div>
        <div className={`mint-flex flex-center mint-grid dp-bg-img ${dpSubscribed ? 'thank-you' : ''}`}>
          {!isMobile && <div className="thank-you-sec" style={thankYouStyle}>
            {dpSubscribed && showThankYouPopup && <>
              <img src={thankYouImg} />
              <div className="thank-you-txt">
                <h4>Thank you</h4>
                <p>We're excited to share our content and insights with you</p>
              </div>
            </>}
          </div>}
          {isMobile && <div id="closeDpBgImg" className="popup-close-btn">
            <img src={crossIcon} />
          </div>}
          <SuccessButton
            style={{ padding: '0px 22px 0 15px' }}
            type="submit"
            value=""
            className="mintbtn-green leadbtn"
            onClick={dpSubscription}
          >
            {dpSubscribed != true ? 'Get notified' : 'Create Leads'}
            <img
              className="notification-icon"
              src={dpSubscribed != true ? notificationIcon : createLeadIcon}
            />
          </SuccessButton>
        </div>
      </>
    );
  };

  return (
    <div className="contentview-popup">
      {showContentViewPopup &&
        <LargePopup
          closable
          onClose={onCancel}
          modalWidth="692px"
          title={activeContentDetails?.heading}
        >
          <OuterContent className="page-height" isMobile={isMobile} onClick={() => closePopup()}>{popupContent()}</OuterContent>
        </LargePopup>}</div>
  );
};
export default SingleViewContentPopup;
